/* unplugin-vue-components disabled */import script from "./SinglePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SinglePage.vue?vue&type=script&setup=true&lang=js"

import "./SinglePage.vue?vue&type=style&index=0&id=a5562f2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5562f2e"]])

export default __exports__